<template>
  <div>
    <div class="text-xs-center mb-2">
      <div class="d-flex">
        <div
          style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          height: 50px;
        "
        >
          <img
            src="@/assets/back-office/icons/chevron_icon_left.svg"
            alt=""
            width="30px"
            @click="$router.back()"
            style="cursor: pointer; margin-left:1vw"
          />
          <h2 class="text-xs-center">
            Transaction Detail
          </h2>
          <div></div>
        </div>
      </div>
    </div>
    <div v-if="this.$route.params.transaction_partner_type == 'Invoice'">
      <invoiceTable />
    </div>
    <div v-else>
      <profitTable />
    </div>
  </div>
</template>

<script>
import invoiceTable from "@/components/back-office/ManagerUserManage/Invoicebill.vue";
import profitTable from "@/components/back-office/ManagerUserManage/Profitbill.vue";
import { mapState } from "vuex";
export default {
  components: {
    invoiceTable,
    profitTable,
  },
  computed: {
    ...mapState({
      recentPath: (state) => state.backOffice.recentRoutePath,
    }),
  },
  destroyed() {
    this.$store.commit("fetchUserBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Manager management",
        disabled: true,
        href: "/weserve_admin_login/control/-/manager-manage",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style></style>
